import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import {useTranslation} from 'react-i18next';
import NewContractFormComponent, {isContractFormValid} from '../NewContractFormComponent';
import type {Contract} from '../../../types/contract';

interface AddContractDialogProps {
    open: boolean;
    newContract: Contract;
    branchName?: string;
    onClose: () => void;
    onSubmit: () => void;
    handleContractFormChange: (field: keyof Contract) => (event: any) => void;
    contractSubmitError?: { message: string; violations: string[] } | null;
}

const AddContractDialog: React.FC<AddContractDialogProps> = ({
                                                                 open,
                                                                 newContract,
                                                                 branchName,
                                                                 onClose,
                                                                 onSubmit,
                                                                 handleContractFormChange,
                                                                 contractSubmitError,
                                                             }) => {
    const {t} = useTranslation();
    const [showAllErrors, setShowAllErrors] = React.useState(false);

    const handleSave = () => {
        if (!isContractFormValid(newContract)) {
            setShowAllErrors(true);
            return;
        }
        setShowAllErrors(false);
        onSubmit();
    };

    const handleClose = () => {
        setShowAllErrors(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={() => {
        }} disableEscapeKeyDown maxWidth={false} PaperProps={{sx: {width: {xs: 'calc(100% - 32px)', sm: '600px'}, margin: 'auto'}}}>
            <DialogTitle>{t('employee.contract.dialog.addTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 2}}>
                    <NewContractFormComponent
                        newContract={newContract}
                        branchName={branchName}
                        handleContractFormChange={handleContractFormChange}
                        showAllErrors={showAllErrors}
                        backendError={contractSubmitError}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    {t('common.actions.cancel')}
                </Button>
                <Button onClick={handleSave} variant="contained" color="primary" startIcon={<SaveIcon/>}>
                    {t('common.actions.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddContractDialog;
